<template>
  <common-dialog ref="dialog" :title="title" width="750px" :in-dialog="inDialog">
    <list ref="list" common :show-checkbox="multiple" :checkbox-fixed="false">
      <template #column v-if="selectable&&!multiple">
        <slot name="column" />
        <el-table-column label="操作" align="center" width="60" fixed="right">
          <template slot-scope="{row}">
            <el-button @click="onSelect(row)" type="text">选择</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <template slot="footer" v-if="selectable&&multiple">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" size="small">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "班级资料",
    },
  },
  methods: {},
};
</script>